import React from 'react';
import { Hero } from './Hero';
import { Capabilities } from './Capabilities';
import { CTA } from './CTA';
export function HighAvailability() {
  return <div className="min-h-screen w-full bg-white" data-id="element-537">
      <Hero data-id="element-538" />
      <Capabilities data-id="element-539" />
      <CTA data-id="element-540" />
    </div>;
}